import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { FIREBASE_API, FIREBASE_DEV_API } from "src/config-global";
import { initializeApp } from "firebase/app";
import SnackbarProvider from "./components/SnackbarProvider";
import Router from "./routes/Router";
import MotionLazy from "./components/MotionLazy";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ja } from "date-fns/locale";
import { createTheme, ThemeProvider, Theme } from "@mui/material/styles";

// const firebaseApp =
//   process.env.REACT_APP_PROD == "true"
//     ? initializeApp(FIREBASE_API)
//     : initializeApp(FIREBASE_DEV_API);

const firebaseApp = initializeApp(FIREBASE_API);

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    iframeXS: true;
    iframeMD: true;
    iframeSM: true;
    laptop: true;
    desktop: true;
  }
}

const theme: Theme = createTheme({
  breakpoints: {
    values: {
      ...createTheme().breakpoints.values,
      iframeXS: 330,
      iframeSM: 350,
      iframeMD: 450,
    },
  },
});
function App() {
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
        <ThemeProvider theme={theme}>
          <MotionLazy>
            <SnackbarProvider>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </SnackbarProvider>
          </MotionLazy>
        </ThemeProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
